import {TrashIcon} from "@heroicons/react/24/outline";
import {BillingUserType} from "data/types";
import React, {FC} from "react";

export interface BillingCardProps {
  selected: BillingUserType | null;
  setSelected: React.Dispatch<React.SetStateAction<BillingUserType | null>>;
  billing: BillingUserType;
  handleDelete: (id: string) => void;
}

const BillingCard: FC<BillingCardProps> = ({
  selected,
  setSelected,
  billing,
  handleDelete,
}) => {
  return (
    <div
      className={`relative rounded-2xl border p-5 flex flex-col min-h-[160px] cursor-pointer transition-all duration-300 ease-in-out transform hover:shadow-lg hover:scale-105
        ${
          selected?._id === billing._id
            ? "border-primary-500 bg-primary-50 dark:bg-primary-900 shadow-2xl scale-100"
            : "border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 shadow-md scale-100"
        }
      `}
      onClick={() => setSelected(billing)}
    >
      <button
        onClick={() => handleDelete(billing._id!)}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-red-100 dark:hover:bg-red-800 transition"
      >
        <TrashIcon className="w-5 h-5 text-red-500" />
      </button>

      <h3 className="text-md font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
        {billing.name}
      </h3>

      <div className="space-y-1 text-xs text-neutral-700 dark:text-neutral-300 flex-1">
        <p>
          <span>{billing.documentType}:</span> {billing.identification}
        </p>
        <p>
          <span>Email:</span> {billing.email}
        </p>
        <p>
          <span>Teléfono:</span> {billing.prefix}
          {billing.phone}
        </p>
        {billing.address && (
          <p>
            <span>Dirección:</span> {billing.address}
          </p>
        )}
      </div>
    </div>
  );
};

export default BillingCard;
